import { useEffect } from 'react';
import L from 'leaflet';
import { allSurveys, surveyDims } from '../lib/survey';

const tag = (ll, html, cls, anchor) => L.marker(ll, { interactive: false, keyboard: false, icon: L.divIcon({ className: cls, html, iconSize: [0, 0], iconAnchor: anchor || [0, 0] }) });

// dashed building-survey dimension lines with metre labels, P1/P2 points and "surveyed" badge
export default function useSurveyLayer(mapRef, on, fittings, pipes) {
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !on) return undefined;
    const g = L.layerGroup().addTo(map);
    allSurveys({ fittings, pipes }).forEach(({ s, pt }) => {
      surveyDims(s, pt).forEach((d) => {
        if (d.base) return g.addLayer(L.polyline([d.p, d.q], { color: '#64748b', weight: 2, dashArray: '4 4', interactive: false, className: 'svy-line svy-base' }));
        g.addLayer(L.polyline([d.p, d.q], { color: '#facc15', weight: 5, opacity: 0.9, interactive: false, className: 'svy-line-under' }));
        g.addLayer(L.polyline([d.p, d.q], { color: '#dc2626', weight: 2.5, dashArray: '7 6', interactive: false, className: 'svy-line' }));
        if (d.label) g.addLayer(tag([(d.p[0] + d.q[0]) / 2, (d.p[1] + d.q[1]) / 2], `<span class="svy-label" data-testid="survey-dim-label">${d.label}</span>`, 'svy-label-wrap'));
      });
      [s.a, s.b].filter(Boolean).forEach((c, k) => {
        g.addLayer(L.circleMarker(c, { radius: 4, color: '#0f172a', weight: 1.5, fillColor: '#facc15', fillOpacity: 1, interactive: false, className: `svy-corner svy-corner-${k ? 'b' : 'a'}` }));
        g.addLayer(tag(c, `<span class="svy-pt">P${k + 1}</span>`, 'svy-mk-wrap'));
      });
      g.addLayer(tag(pt, '<span class="svy-badge" data-testid="survey-badge">📐✓</span>', 'svy-badge-wrap'));
    });
    return () => g.remove();
  }, [mapRef, on, fittings, pipes]);
}
